<template>
  <div class="result_warpper">
    <nav-bar titleText="认证结果" titleWeight="bold" @goBack="goBack"></nav-bar>
    <results-page
      @handleOperationClick="handleOperationClick"
      @handleReturnClick="handleReturnClick"
      :operationDisplab="showOperate"
      :operationText="operateText"
      :returnDisplab="showReturn"
      :returnText="returnText"
      :instructions="instructions"
      :imgSrc="imgSrc"
    ></results-page>
  </div>
</template>
<script>
import navBar from "../../debtRelief/components/navBar";
import resultsPage from "../../debtRelief/components/resultsPage";
export default {
  data() {
    return {
      showOperate: false,
      showReturn: false,
      operateText: '',
      returnText: '',
      instructions: '',
      imgSrc: '',
      status: 0
    };
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.getResult();
  },
  components: {
    navBar,
    resultsPage,
  },
  methods: {
    getResult() {
      this.$api.get('member/member/company/auth/detail')
      .then(res => {
        this.status = res.status;
        if(this.status == 2) {//成功
          this.showReturn = true;
          this.returnText = '进入首页';
          this.instructions = '已成功认证';
          this.imgSrc = require("../../../assets/debtor/resultOk.png");
        }else if(this.status == 1) {//审核中
          this.showReturn = true;
          this.returnText = '返回';
          this.instructions = '认证审核中';
          this.imgSrc = require("../../../assets/debtor/inProcess.png");
        }else if(this.status == -1) {//失败
          this.showOperate = true;
          this.operateText = '再次认证';
          this.instructions = '认证失败'+<br />+'原因：'+res.failtrueReason;
          this.imgSrc = require("../../../assets/debtor/authReject.png");
        }
      })
      .catch(err => {
        console.log(err);
        let keys = Object.keys(err);
        let key = keys[0];
        let message = err.message || err[key][0]
        this.$toast(message)
      })
    },
    goBack() {
      this.params("", "", "goBack");
      // if(this.$route.query.from) {
      //   this.$router.go(-1);
      // }else {
      //   this.params("", "", "goBack");
      // }
    },
    goHome() {
      this.params("", "", "goHome");
    },
    handleOperationClick() {
      this.$router.push({
        path: '/companyInfo',
        query: {
          token: this.$route.query.token
        }
      })
    },
    handleReturnClick() {
      if(this.status == 2) {
        this.goHome();
      }else if(this.status == 1) {
        this.goBack();
      }
    },
  },
};
</script>
<style lang="less">
.result_warpper {
  padding-top: 88px;
  box-sizing: border-box;
  background-color: #f5f6f7;
  min-height: 100%;
  font-size: 16px;
  color: #333;
}
</style>
